import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'appMediumDate',
  standalone: true
})
export class AppMediumDatePipe implements PipeTransform {

  transform(date: Date | null | undefined, showMilliseconds = false): unknown {
    if (!date) {
      return null;
    }

    return AppMediumDatePipe.transformDate(date, showMilliseconds);
  }

  static transformDate(date: Date, showMilliseconds = false): string {
    var dateTime = DateTime.fromJSDate(new Date(date));
    
    var dateStr = dateTime.toLocaleString(DateTime.DATE_SHORT);
    var time = dateTime.toFormat(`H:mm:ss${showMilliseconds ? '.SSS' : ''}`);

    return dateTime.isValid ? `${dateStr} ${time}` : '';
  }

}
